import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { Row, Col, Card, Spinner, Badge, Tabs, Tab, Button, Table, Pagination, Modal, Form } from "react-bootstrap";
import {
  FaBook, FaCode, FaLanguage, FaCalendarAlt, FaClock,
  FaUserTie, FaImage, FaArrowLeft, FaEdit, FaCheckCircle, FaTimesCircle,
  FaCalendar, FaGraduationCap, FaInfoCircle, FaTag, FaStar, FaEye, FaTrash, FaPlus, FaToggleOn, FaToggleOff, FaCopy,
} from "react-icons/fa";


import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { ToastContainer, toast } from "react-toastify";
import { formateDatemdy, capitalizeFirstLetterOfEveryWord } from "../../utils/Helper";
import DeleteModal from "../../components/common/DeleteModel";
import Select from "react-select";
import useMenuPermissions from "../../components/CustomHook/custompermission";

const CourseDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout, data } = useContext(UserContext);
  const permissionscontext = useMenuPermissions("/admin/topic");
  const permissionscontextSchool = useMenuPermissions("/admin/school");
  const [duplicating, setDuplicating] = useState(false);
  const [updatingPublish, setUpdatingPublish] = useState(false);

  const headers = {
    "auth-token": authToken,
    "authorization": accessToken
  };

  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [loading, setLoading] = useState(false);
  const [courseData, setCourseData] = useState(null);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedSchoolId, setSelectedSchoolId] = useState("");
  const [allSchools, setAllSchools] = useState([]);
  const [loadingSchoolsList, setLoadingSchoolsList] = useState(false);
  // Topic management states
  const [showTopicEditModal, setShowTopicEditModal] = useState(false);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [topicName, setTopicName] = useState("");
  const [showTopicDeleteModal, setShowTopicDeleteModal] = useState(false);
  const [selectedTopicId, setSelectedTopicId] = useState(null);
  const [editLoad, setEditLoad] = useState(false);

  // Schools state
  const [schools, setSchools] = useState([]);
  const [loadingSchools, setLoadingSchools] = useState(false);
  const [schoolsTotal, setSchoolsTotal] = useState(0);
  const [schoolsCurrentPage, setSchoolsCurrentPage] = useState(1);
  const schoolsLimit = 10;
  const [allSchoolsList, setAllSchoolsList] = useState([]);
  // Students state
  const [students, setStudents] = useState([]);
  const [loadingStudents, setLoadingStudents] = useState(false);
  const [studentsTotal, setStudentsTotal] = useState(0);
  const [studentsCurrentPage, setStudentsCurrentPage] = useState(1);
  const [studentFilters, setStudentFilters] = useState({
    search: "",
    school_id: "",
    grade_id: ""
  });
  const [grades, setGrades] = useState([]);
  const [loadingGrades, setLoadingGrades] = useState(false);
  const studentsLimit = 10;

  // Topics state
  const [topics, setTopics] = useState([]);
  const [loadingTopics, setLoadingTopics] = useState(false);
  const [topicsTotal, setTopicsTotal] = useState(0);
  const [topicsCurrentPage, setTopicsCurrentPage] = useState(1);
  const [topicsFilters, setTopicsFilters] = useState({
    name: "",
    status: ""
  });
  const topicsLimit = 10;


  // Add this state near other states
  const [activeTab, setActiveTab] = useState(() => {
    // Check URL query parameter for tab
    const queryParams = new URLSearchParams(window.location.search);
    const tabParam = queryParams.get('tab');
    if (tabParam && ['info', 'topics', 'schools', 'students'].includes(tabParam)) {
      return tabParam;
    }
    return 'info';
  });

  // Add this function to handle tab change
  const handleTabSelect = (tabKey) => {
    setActiveTab(tabKey);
    // Update URL without page reload
    const url = new URL(window.location.href);
    url.searchParams.set('tab', tabKey);
    window.history.pushState({}, '', url);
  };

  useEffect(() => {
    if (id) {
      fetchCourseDetails();
    }
  }, [id]);


  useEffect(() => {
    if (showAssignModal) {
      fetchAllSchools();
    }
  }, [showAssignModal]);

  useEffect(() => {
    if (activeTab === 'schools' && id) {
      fetchAssignedSchools(schoolsCurrentPage);
    }
  }, [activeTab, id, schoolsCurrentPage]);

  const fetchCourseDetails = async () => {
    setLoading(true);
    try {
      const response = await APIServices.get(
        `/admin/courses/${id}`,
        headers
      );

      if (response?.data?.status === true) {
        setCourseData(response?.data?.data);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        showToast(response?.data?.message || "Error fetching course details", "error");
      }
    } catch (error) {
      console.error("Error fetching course details:", error);
      showToast("Error fetching course details", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchGrades = async () => {
    setLoadingGrades(true);
    try {
      const response = await APIServices.get(
        `/admin/cms/grade_list?status=Active&limit=100`,
        headers
      );
      if (response?.data?.status === true) {
        const gradesData = response?.data?.data?.grades || response?.data?.data?.data || [];
        setGrades(gradesData);
      }
    } catch (error) {
      console.error("Error fetching grades:", error);
    } finally {
      setLoadingGrades(false);
    }
  };

  const fetchCourseStudents = async (page = 1) => {
    setLoadingStudents(true);
    try {
      const skip = (page - 1) * studentsLimit;
      let url = `/admin/student/list?skip=${skip}&limit=${studentsLimit}&course_id=${id}`;

      if (studentFilters.search) {
        url += `&search=${studentFilters.search}`;
      }
      if (studentFilters.school_id) {
        url += `&school_id=${studentFilters.school_id}`;
      }
      if (studentFilters.grade_id) {
        url += `&grade_id=${studentFilters.grade_id}`;
      }

      const response = await APIServices.get(url, headers);

      if (response?.data?.status === true) {
        setStudents(response?.data?.data?.data || []);
        setStudentsTotal(response?.data?.data?.total || 0);
      }
    } catch (error) {
      console.error("Error fetching students:", error);
      showToast("Error fetching students", "error");
    } finally {
      setLoadingStudents(false);
    }
  };

  useEffect(() => {
    fetchGrades();
    fetchAllSchools();
  }, []);

  useEffect(() => {
    if (activeTab === 'students' && id) {
      fetchCourseStudents(studentsCurrentPage);
    }
  }, [activeTab, id, studentsCurrentPage, studentFilters]);

  const handleStudentSearch = (e) => {
    setStudentFilters(prev => ({ ...prev, search: e.target.value }));
    setStudentsCurrentPage(1);
  };

  const handleSchoolFilter = (e) => {
    setStudentFilters(prev => ({ ...prev, school_id: e.target.value }));
    setStudentsCurrentPage(1);
  };

  const handleGradeFilter = (e) => {
    setStudentFilters(prev => ({ ...prev, grade_id: e.target.value }));
    setStudentsCurrentPage(1);
  };

  const clearStudentFilters = () => {
    setStudentFilters({ search: "", school_id: "", grade_id: "" });
    setStudentsCurrentPage(1);
  };
  const fetchAssignedSchools = async (page = 1) => {
    setLoadingSchools(true);
    try {
      const skip = (page - 1) * schoolsLimit;
      const response = await APIServices.get(
        `/admin/courses/mapping/course-schools/${id}?skip=${skip}&limit=${schoolsLimit}`,
        headers
      );

      if (response?.data?.status === true) {
        setSchools(response?.data?.data?.schools || []);
        setSchoolsTotal(response?.data?.data?.total || 0);
      }
    } catch (error) {
      console.error("Error fetching assigned schools:", error);
      showToast("Error fetching schools", "error");
    } finally {
      setLoadingSchools(false);
    }
  };


  // Update Publish Status using FormData
  const handlePublishChange = async (course) => {
    const newPublishStatus = course.published_status === "Published" ? "Draft" : "Published";

    const formData = new FormData();
    formData.append("id", course.id);
    formData.append("status", newPublishStatus);

    setUpdatingPublish(true);
    try {
      const res = await APIServices.put(
        `/admin/courses/publish`,
        formData,
        {
          ...headers,
          'Content-Type': 'multipart/form-data'
        }
      );
      if (res?.data?.status == true) {
        showToast(res?.data?.message || "Publish status updated successfully", "success");
        fetchCourseDetails();
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Error updating publish status:", error);
      showToast("Error updating publish status", "error");
    } finally {
      setUpdatingPublish(false);
    }
  };

  const handleRemoveSchool = async () => {
    try {
      const formData = new FormData();
      formData.append("course_id", id);
      formData.append("school_id", selectedSchool.id);

      const response = await APIServices.delete(
        "/admin/courses/mapping/delete",
        formData,
        {
          ...headers,
          'Content-Type': 'multipart/form-data'
        }
      );

      if (response?.data?.status === true) {
        showToast(response?.data?.message || "School removed from course successfully", "success");
        setShowDeleteModal(false);
        setSelectedSchool(null);
        // Refresh the schools list
        fetchAssignedSchools(schoolsCurrentPage);
      } else {
        showToast(response?.data?.message || "Something went wrong", "error");
      }
    } catch (error) {
      console.error("Error removing school:", error);
      showToast("Error removing school from course", "error");
    }
  };

  const encryptId = (id) => {
    return btoa(encodeURIComponent(id));
  };


  const fetchAllSchools = async () => {
    setLoadingSchoolsList(true);
    try {
      const response = await APIServices.get(
        `/admin/school/short_list`,
        headers
      );

      if (response?.data?.status === true) {
        const schoolsData = response?.data?.data?.data || [];
        console.log("schoolsData", schoolsData)
        const formattedSchools = schoolsData.map(school => ({
          value: school.id,
          label: `${school.school_name} (${school.school_code})`
        }));
        setAllSchools(formattedSchools);
        setAllSchoolsList(formattedSchools); // For student filter
      }
    } catch (error) {
      console.error("Error fetching schools:", error);
      showToast("Error fetching schools", "error");
    } finally {
      setLoadingSchoolsList(false);
    }
  };


  const handleAssignSchool = async () => {
    if (!selectedSchoolId) {
      showToast("Please select a school", "error");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("course_id", id);
      formData.append("school_id", selectedSchoolId.value);

      const response = await APIServices.post(
        "/admin/courses/mapping/add",
        formData,
        {
          ...headers,
          'Content-Type': 'multipart/form-data'
        }
      );

      if (response?.data?.status === true) {
        showToast(response?.data?.message || "School assigned successfully", "success");
        setShowAssignModal(false);
        setSelectedSchoolId("");
        // Refresh the schools list
        fetchAssignedSchools(schoolsCurrentPage);
      } else {
        showToast(response?.data?.message || "Something went wrong", "error");
      }
    } catch (error) {
      console.error("Error assigning school:", error);
      showToast("Error assigning school to course", "error");
    }
  };


  const handleTopicNameFilter = (e) => {
    setTopicsFilters(prev => ({ ...prev, name: e.target.value }));
    setTopicsCurrentPage(1);
  };

  const handleTopicStatusFilter = (e) => {
    setTopicsFilters(prev => ({ ...prev, status: e.target.value }));
    setTopicsCurrentPage(1);
  };

  const clearTopicFilters = () => {
    setTopicsFilters({ name: "", status: "" });
    setTopicsCurrentPage(1);
  };

  useEffect(() => {
    if (activeTab === 'topics' && id) {
      fetchCourseTopics(topicsCurrentPage);
    }
  }, [activeTab, id, topicsCurrentPage, topicsFilters]);


  const fetchCourseTopics = async (page = 1) => {
    setLoadingTopics(true);
    try {
      const skip = (page - 1) * topicsLimit;
      let url = `/admin/topics/topic_by_course?skip=${skip}&limit=${topicsLimit}&course_id=${id}`;

      if (topicsFilters.name) {
        url += `&name=${topicsFilters.name}`;
      }
      if (topicsFilters.status) {
        url += `&status=${topicsFilters.status}`;
      }

      const response = await APIServices.get(url, headers);

      if (response?.data?.status === true) {
        setTopics(response?.data?.data?.topics || []);
        setTopicsTotal(response?.data?.data?.total || 0);
      }
    } catch (error) {
      console.error("Error fetching topics:", error);
      showToast("Error fetching topics", "error");
    } finally {
      setLoadingTopics(false);
    }
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };

  const handleDuplicateCourse = async () => {
    setDuplicating(true);
    try {
      const formData = new FormData();
      formData.append("id", id);

      const response = await APIServices.post(
        "/admin/courses/duplicate",
        formData,
        {
          ...headers,
          'Content-Type': 'multipart/form-data'
        }
      );

      if (response?.data?.status === true) {
        showToast(response?.data?.message || "Course duplicated successfully", "success");
        setTimeout(() => {
          navigate("/admin/course");
        }, 1500);
      } else {
        showToast(response?.data?.message || "Something went wrong", "error");
      }
    } catch (error) {
      console.error("Error duplicating course:", error);
      showToast("Error duplicating course", "error");
    } finally {
      setDuplicating(false);
    }
  };

  const getStatusBadge = (status) => {
    if (status === "Active") {
      return <Badge bg="success" className="px-3 py-3">Active</Badge>;
    } else if (status === "Inactive") {
      return <Badge bg="danger" className="px-3 py-3">Inactive</Badge>;
    }
    return <Badge bg="secondary" className="px-3 py-3">Unknown</Badge>;
  };

  const getApprovalBadge = (approval) => {
    if (approval === "Approved") {
      return <Badge bg="success" className="px-3 py-2"><FaCheckCircle className="me-1" /> Approved</Badge>;
    } else if (approval === "Pending") {
      return <Badge bg="warning" className="px-3 py-2">Pending</Badge>;
    } else if (approval === "Rejected") {
      return <Badge bg="danger" className="px-3 py-2"><FaTimesCircle className="me-1" /> Rejected</Badge>;
    }
    return <Badge bg="secondary" className="px-3 py-2">{approval}</Badge>;
  };


  // Handle topic status change
  const handleTopicStatusChange = async (topic) => {
    const newStatus = topic.status === "Active" ? "Inactive" : "Active";
    try {
      const payload = { id: topic.id, status: newStatus };
      const res = await APIServices.put(
        `/admin/topics/status`,
        payload,
        headers
      );
      if (res?.data?.status === true) {
        showToast(res?.data?.message || "Status updated successfully", "success");
        // Refresh topics list
        fetchCourseTopics(topicsCurrentPage);
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      showToast("Error updating status", "error");
    }
  };

  // Handle topic publish status change
  const handleTopicPublishChange = async (topic) => {
    const newStatus = topic.published_status === "Published" ? "Draft" : "Published";
    try {
      const payload = { id: topic.id, published_status: newStatus };
      const res = await APIServices.put(
        `/admin/topics/publish`,
        payload,
        headers
      );
      if (res?.data?.status === true) {
        showToast(res?.data?.message || "Publish status updated successfully", "success");
        // Refresh topics list
        fetchCourseTopics(topicsCurrentPage);
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Error updating publish status:", error);
      showToast("Error updating publish status", "error");
    }
  };

  // Handle topic edit
  const handleTopicEdit = async () => {
    if (!topicName?.trim()) {
      showToast("Please enter topic name", "error");
      return;
    }
    setEditLoad(true);
    try {
      const payload = { name: topicName };
      const res = await APIServices.put(
        `/admin/topics/${selectedTopic.id}`,
        payload,
        headers
      );
      if (res?.data?.status === true) {
        showToast(res?.data?.message || "Topic updated successfully", "success");
        setShowTopicEditModal(false);
        setSelectedTopic(null);
        setTopicName("");
        // Refresh topics list
        fetchCourseTopics(topicsCurrentPage);
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Error updating topic:", error);
      showToast("Error updating topic", "error");
    } finally {
      setEditLoad(false);
    }
  };

  // Handle topic delete
  const handleTopicDelete = async () => {
    try {
      if (selectedTopicId) {
        const payload = { id: selectedTopicId };
        const res = await APIServices.put(
          `/admin/topics/delete/${selectedTopicId}`,
          payload,
          headers
        );
        if (res?.data?.status === true) {
          showToast(res?.data?.message || "Topic deleted successfully", "success");
          setShowTopicDeleteModal(false);
          setSelectedTopicId(null);
          // Refresh topics list
          fetchCourseTopics(topicsCurrentPage);
        } else {
          showToast(res?.data?.message || "Something went wrong.", "error");
        }
      }
    } catch (error) {
      console.error("Error deleting topic:", error);
      showToast("Error deleting topic", "error");
    }
  };

  const getPublishedBadge = (published) => {
    if (published === "Published") {
      return <Badge bg="success" className="px-3 py-2">Published</Badge>;
    } else if (published === "Draft") {
      return <Badge bg="warning" className="px-3 py-2">Draft</Badge>;
    }
    return <Badge bg="secondary" className="px-3 py-2">{published}</Badge>;
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Loading course details...</p>
      </div>
    );
  }

  if (!courseData) {
    return (
      <div className="text-center py-5">
        <p>No data found</p>
        <Button variant="primary" onClick={() => navigate("/admin/course")}>
          Back to Courses
        </Button>
      </div>
    );
  }

  return (
    <>
      <div className="course-details-page">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1 className="font_blue_18 font-600 ms-2">
            Course Details
          </h1>

          <div className="d-flex gap-2">
            {permissionscontext.add == 1 && (
              <button
                className="btn red_button d-flex align-items-center"
                onClick={handleDuplicateCourse}
                disabled={duplicating}
                title="Duplicate this course"
              >
                <FaCopy className="me-1" />
                {duplicating ? "Duplicating..." : "Duplicate"}
              </button>
            )}
            {permissionscontext.add == 1 && (
              <button
                className="btn red_button d-flex align-items-center"
                onClick={() => navigate(`/admin/generate-topic?id=${encryptId(id)}`)}
                title="Manage or Genrate New Topics For This Course"
              >
                <FaPlus className="me-1" />
                Manage Topic
              </button>
            )}
            <Button
              variant="outline-secondary"
              onClick={() => navigate("/admin/course")}
            >
              <FaArrowLeft className="me-1" /> Back
            </Button>
          </div>
        </div>

        <Row>
          {/* Left Sidebar - 4 Columns - Single Card */}
          <Col md={4}>
            <Card>
              <Card.Body>
                {/* Course Image */}
                <div className="text-center mb-3">
                  {courseData.image ? (
                    <img
                      src={courseData.image}
                      alt={courseData.title}
                      style={{
                        width: '100%',
                        height: '200px',
                        objectFit: 'cover',
                        borderRadius: '10px',
                        marginBottom: '10px'
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: '100%',
                        height: '200px',
                        backgroundColor: '#f0f0f0',
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: '10px'
                      }}
                    >
                      <FaBook size={60} color="#999" />
                    </div>
                  )}
                  <h4><strong>{capitalizeFirstLetterOfEveryWord(courseData.title)}</strong></h4>
                  <p className="text-muted">{courseData.unique_course_id}</p>
                  <div className="mt-2 d-flex justify-content-center gap-2 flex-wrap">
                    {getStatusBadge(courseData.status)}
                    <Button
                      variant={courseData.published_status === "Published" ? "success" : "warning"}
                      size="sm"
                      onClick={() => handlePublishChange(courseData)}
                      disabled={!permissionscontext.edit}
                      className="d-flex align-items-center gap-1"
                    >
                      {courseData.published_status === "Published" ? (
                        <FaToggleOn size={25} className="position-relative" />
                      ) : (
                        <FaToggleOff size={25} className="position-relative" />
                      )}
                      {courseData.published_status}
                    </Button>


                    {courseData.expiry_date && new Date(courseData.expiry_date) < new Date() && (
                      <Badge bg="danger pt-2">Expired</Badge>
                    )}
                  </div>
                </div>

                <hr />

                {/* Course Details */}
                <div className="course-info">
                  <div className="d-flex justify-content-between mb-3 pb-2 border-bottom">
                    <strong>Course ID:</strong>
                    <span>{courseData.unique_course_id}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-3 pb-2 border-bottom">
                    <strong>Duration:</strong>
                    <span>{courseData.duration}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-3 pb-2 border-bottom">
                    <strong>Language:</strong>
                    <span>{courseData.language}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-3 pb-2 border-bottom">
                    <strong>Expiry Date:</strong>
                    <span>{formateDatemdy(courseData.expiry_date)}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-3 pb-2 border-bottom">
                    <strong>Created At:</strong>
                    <span>{formateDatemdy(courseData.created_at)}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-3 pb-2 border-bottom">
                    <strong>Last Updated:</strong>
                    <span>{courseData.updated_at ? formateDatemdy(courseData.updated_at) : 'N/A'}</span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Right Content - 8 Columns with Tabs */}
          <Col md={8}>
            <Card>
              <Card.Body>
                <Tabs
                  activeKey={activeTab}
                  onSelect={handleTabSelect}
                  className="mb-3"
                >
                  {/* Tab 1: Course Info */}
                  <Tab eventKey="info" title="Course Info">
                    <div className="p-3">
                      <div className="card p-3 shadow-sm">
                        <h6 className="text-primary mb-3">Course Information</h6>

                        <div className="row">
                          <div className="col-md-12 mb-3">
                            <div className="text-muted small">Title</div>
                            <div className="fw-semibold">{courseData.title || 'N/A'}</div>
                          </div>

                          <div className="col-md-12 mb-3">
                            <div className="text-muted small">Sub Title</div>
                            <div className="fw-semibold">{courseData.sub_title || 'N/A'}</div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <div className="text-muted small">Duration</div>
                            <div className="fw-semibold">{courseData.duration || 'N/A'}</div>
                          </div>

                          <div className="col-md-6 mb-3">
                            <div className="text-muted small">Language</div>
                            <div className="fw-semibold">{courseData.language || 'N/A'}</div>
                          </div>

                          <div className="col-md-6 mb-3">
                            <div className="text-muted small">Expiry Date</div>
                            <div className="fw-semibold">
                              {formateDatemdy(courseData.expiry_date)}
                            </div>
                          </div>

                          <div className="col-md-6 mb-3">
                            <div className="text-muted small">Created At</div>
                            <div className="fw-semibold">{formateDatemdy(courseData.created_at)}</div>
                          </div>

                          <div className="col-md-12 mb-3">
                            <div className="text-muted small">Grades Offered</div>
                            <div>
                              {courseData.grade_names?.length > 0 ? (
                                courseData.grade_names.map((grade, index) => (
                                  <Badge key={index} bg="info" className="me-1 mb-1">
                                    {grade}
                                  </Badge>
                                ))
                              ) : 'N/A'}
                            </div>
                          </div>
                          <div className="col-md-12 mb-3">
                            <div className="text-muted small">Description</div>
                            <div className="fw-semibold">
                              <div
                                className="right w-100"
                                dangerouslySetInnerHTML={{
                                  __html: courseData?.description || "",
                                }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab>

                  {/* Tab 2: Topics */}
                  <Tab eventKey="topics" title="Topics">
                    <div className="p-3">
                      <div className="d-flex justify-content-between align-items-center mb-3 gap-2 flex-wrap">
                        <h6 className="text-primary mb-0">Course Topics</h6>
                        <div className="d-flex gap-2 flex-wrap">
                          {/* Search by Name */}
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search by topic name..."
                            value={topicsFilters.name}
                            onChange={handleTopicNameFilter}
                            style={{ width: '200px' }}
                          />

                          {/* Status Filter */}
                          <Form.Select
                            value={topicsFilters.status}
                            onChange={handleTopicStatusFilter}
                            style={{ width: '150px' }}
                          >
                            <option value="">All Status</option>
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                          </Form.Select>

                          {/* Clear Filters Button */}
                          {(topicsFilters.name || topicsFilters.status) && (
                            <Button variant="outline-danger" size="sm" onClick={clearTopicFilters}>
                              Clear Filters
                            </Button>
                          )}
                        </div>
                      </div>


                      {loadingTopics ? (
                        <div className="text-center py-4">
                          <Spinner animation="border" variant="primary" />
                        </div>
                      ) : topics.length > 0 ? (
                        <>
                          <Table responsive className="table">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Topic Name</th>
                                <th>Created Date</th>
                                <th>Lesson</th>
                                <th>Published Status</th>
                                <th>Status</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {topics.map((topic, index) => (
                                <tr key={topic.id}>
                                  <td>{((topicsCurrentPage - 1) * topicsLimit) + index + 1}</td>
                                  <td>{topic.name}</td>
                                  <td>{formateDatemdy(topic.created_at)}</td>
                                  <td>{topic.no_of_lesson || 0}</td>
                                  <td>
                                    <Form className="Switch_toggle">
                                      <input
                                        type="checkbox"
                                        id={`switchP-${topic.id}`}
                                        checked={topic.published_status === "Published"}
                                        disabled={!permissionscontext.edit}
                                        onChange={() => handleTopicPublishChange(topic)}
                                      />
                                      <label
                                        htmlFor={`switchP-${topic.id}`}
                                        className="position-relative"
                                      >
                                        Toggle
                                      </label>
                                    </Form>
                                  </td>
                                  <td>
                                    <Form className="Switch_toggle">
                                      <input
                                        type="checkbox"
                                        id={`switch-${topic.id}`}
                                        checked={topic.status === "Active"}
                                        disabled={!permissionscontext.edit}
                                        onChange={() => handleTopicStatusChange(topic)}
                                      />
                                      <label
                                        htmlFor={`switch-${topic.id}`}
                                        className="position-relative"
                                      >
                                        Toggle
                                      </label>
                                    </Form>
                                  </td>
                                  <td>
                                    <div className="d-flex gap-2">
                                      {/* View button - Always visible */}
                                      <Button
                                        variant="outline-info"
                                        size="sm"
                                        onClick={() => navigate(`/admin/topic-detail/${topic.id}`)}
                                        title="View Topic Details"
                                      >
                                        <FaEye />
                                      </Button>

                                      {/* Edit button - Hide if topic has lessons (no_of_lesson > 0) */}
                                      {topic.no_of_lesson === 0 &&  permissionscontext.edit == 1 && (
                                        <Button
                                          variant="outline-primary"
                                          size="sm"
                                          disabled={!permissionscontext.edit}
                                          onClick={() => {
                                            setSelectedTopic(topic);
                                            setTopicName(topic.name);
                                            setShowTopicEditModal(true);
                                          }}
                                          title="Edit Topic"
                                        >
                                          <FaEdit />
                                        </Button>
                                      )}

                                      {/* Delete button - Hide if topic has lessons (no_of_lesson > 0) */}
                                      {topic.no_of_lesson === 0 && permissionscontext.delete == 1 && (
                                        <Button
                                          variant="outline-danger"
                                          size="sm"
                                          disabled={!permissionscontext.delete}
                                          onClick={() => {
                                            setSelectedTopicId(topic.id);
                                            setShowTopicDeleteModal(true);
                                          }}
                                          title="Delete Topic"
                                        >
                                          <FaTrash />
                                        </Button>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>

                          {/* Pagination */}
                          {topicsTotal > topicsLimit && (
                            <div className="d-flex justify-content-end mt-3">
                              <Pagination>
                                <Pagination.Prev
                                  disabled={topicsCurrentPage === 1}
                                  onClick={() => setTopicsCurrentPage(prev => prev - 1)}
                                />
                                {[...Array(Math.ceil(topicsTotal / topicsLimit))].map((_, i) => (
                                  <Pagination.Item
                                    key={i + 1}
                                    active={topicsCurrentPage === i + 1}
                                    onClick={() => setTopicsCurrentPage(i + 1)}
                                  >
                                    {i + 1}
                                  </Pagination.Item>
                                ))}
                                <Pagination.Next
                                  disabled={topicsCurrentPage === Math.ceil(topicsTotal / topicsLimit)}
                                  onClick={() => setTopicsCurrentPage(prev => prev + 1)}
                                />
                              </Pagination>
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="text-center py-4">
                          <p className="text-muted">No topics found for this course</p>

                        </div>
                      )}
                    </div>
                  </Tab>

                  {/* Tab 3: Schools - Only visible for admin users (not school admin) */}
                  {data?.user_type !== "school" && (
                    <Tab eventKey="schools" title="Schools">
                      <div className="p-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h6 className="text-primary mb-0">Assigned Schools</h6>
                          {permissionscontextSchool.add === 1 && <Button
                            variant="primary"
                            size="sm"
                            onClick={() => setShowAssignModal(true)}
                          >
                            <FaPlus className="me-1" /> Assign School
                          </Button>}
                        </div>

                        {loadingSchools ? (
                          <div className="text-center py-4">
                            <Spinner animation="border" variant="primary" />
                          </div>
                        ) : schools.length > 0 ? (
                          <>
                            <Table className="table">
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th>School Name</th>
                                  <th>School Code</th>
                                  <th>Registration Number</th>
                                  <th>Address</th>
                                  <th>Status</th>
                                  <th>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {schools.map((school, index) => (
                                  <tr key={school.id}>
                                    <td>{((schoolsCurrentPage - 1) * schoolsLimit) + index + 1}</td>
                                    <td>
                                      <strong>{school.school_name}</strong>
                                    </td>
                                    <td>{school.school_code}</td>
                                    <td>{school.registration_number}</td>
                                    <td>{school.address || 'N/A'}</td>
                                    <td>
                                      <Badge bg={school.status === "Active" ? "success" : "danger"}>
                                        {school.status}
                                      </Badge>
                                    </td>
                                    <td>
                                      <div className="d-flex gap-2">
                                        <Button
                                          variant="outline-info"
                                          size="sm"
                                          onClick={() => navigate(`/admin/school-detail/${school.id}`)}
                                          title="View School Details"
                                        >
                                          <FaEye />
                                        </Button>
                                        {permissionscontextSchool.delete &&
                                          <Button
                                            variant="outline-danger"
                                            size="sm"
                                            onClick={() => {
                                              setSelectedSchool(school);
                                              setShowDeleteModal(true);
                                            }}
                                            title="Remove school from this course"
                                          >
                                            <FaTrash />
                                          </Button>
                                        }
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>

                            {/* Pagination */}
                            {schoolsTotal > schoolsLimit && (
                              <div className="d-flex justify-content-end mt-3">
                                <Pagination>
                                  <Pagination.Prev
                                    disabled={schoolsCurrentPage === 1}
                                    onClick={() => setSchoolsCurrentPage(prev => prev - 1)}
                                  />
                                  {[...Array(Math.ceil(schoolsTotal / schoolsLimit))].map((_, i) => (
                                    <Pagination.Item
                                      key={i + 1}
                                      active={schoolsCurrentPage === i + 1}
                                      onClick={() => setSchoolsCurrentPage(i + 1)}
                                    >
                                      {i + 1}
                                    </Pagination.Item>
                                  ))}
                                  <Pagination.Next
                                    disabled={schoolsCurrentPage === Math.ceil(schoolsTotal / schoolsLimit)}
                                    onClick={() => setSchoolsCurrentPage(prev => prev + 1)}
                                  />
                                </Pagination>
                              </div>
                            )}
                          </>
                        ) : (
                          <div className="text-center py-4">
                            <p className="text-muted">No schools assigned to this course</p>
                          </div>
                        )}
                      </div>
                    </Tab>
                  )}

                  {/* Tab 4: Students */}
                  <Tab eventKey="students" title="Students">
                    <div className="p-3">
                      <div className="d-flex justify-content-between align-items-center mb-3 gap-2 flex-wrap">
                        <h6 className="text-primary mb-0">Students Enrolled</h6>
                        <div className="d-flex gap-2 flex-wrap">
                          {/* Search Input */}
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search by name, roll number..."
                            value={studentFilters.search}
                            onChange={handleStudentSearch}
                            style={{ width: '200px' }}
                          />

                          {/* School Filter - Hide for school admin */}
                          {data?.user_type !== "school" && (
                            <Form.Select
                              value={studentFilters.school_id}
                              onChange={handleSchoolFilter}
                              style={{ width: '180px' }}
                            >
                              <option value="">All Schools</option>
                              {allSchools.map(school => (
                                <option key={school.value} value={school.value}>
                                  {school.label}
                                </option>
                              ))}
                            </Form.Select>
                          )}

                          {/* Grade Filter */}
                          <Form.Select
                            value={studentFilters.grade_id}
                            onChange={handleGradeFilter}
                            style={{ width: '150px' }}
                          >
                            <option value="">All Grades</option>
                            {grades.map(grade => (
                              <option key={grade.id} value={grade.id}>{grade.name}</option>
                            ))}
                          </Form.Select>

                          {/* Clear Filters Button */}
                          {(studentFilters.search || studentFilters.school_id || studentFilters.grade_id) && (
                            <Button variant="outline-danger" size="sm" onClick={clearStudentFilters}>
                              Clear Filters
                            </Button>
                          )}
                        </div>
                      </div>

                      {loadingStudents ? (
                        <div className="text-center py-4">
                          <Spinner animation="border" variant="primary" />
                        </div>
                      ) : students.length > 0 ? (
                        <>
                          <Table responsive className="table">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Roll Number</th>
                                <th>Student Name</th>
                                <th>Mobile</th>
                                <th>School</th>
                                <th>Grade</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {students.map((student, index) => (
                                <tr key={student.id}>
                                  <td>{((studentsCurrentPage - 1) * studentsLimit) + index + 1}</td>
                                  <td>{student.roll_number}</td>
                                  <td>{student.first_name} {student.last_name}</td>
                                  <td>{student.country_code}-{student.mobile}</td>
                                  <td>{student.school_name}</td>
                                  <td><Badge bg="info">{student.grade_name}</Badge></td>

                                  <td>
                                    <div className="d-flex gap-2">
                                      <Button
                                        variant="outline-info"
                                        size="sm"
                                        onClick={() => navigate(`/admin/student-detail/${student.id}`)}
                                        title="View Student Details"
                                      >
                                        <FaEye />
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>

                          {/* Pagination */}
                          {studentsTotal > studentsLimit && (
                            <div className="d-flex justify-content-end mt-3">
                              <Pagination>
                                <Pagination.Prev
                                  disabled={studentsCurrentPage === 1}
                                  onClick={() => setStudentsCurrentPage(prev => prev - 1)}
                                />
                                {[...Array(Math.ceil(studentsTotal / studentsLimit))].map((_, i) => (
                                  <Pagination.Item
                                    key={i + 1}
                                    active={studentsCurrentPage === i + 1}
                                    onClick={() => setStudentsCurrentPage(i + 1)}
                                  >
                                    {i + 1}
                                  </Pagination.Item>
                                ))}
                                <Pagination.Next
                                  disabled={studentsCurrentPage === Math.ceil(studentsTotal / studentsLimit)}
                                  onClick={() => setStudentsCurrentPage(prev => prev + 1)}
                                />
                              </Pagination>
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="text-center py-4">
                          <p className="text-muted">No students enrolled in this course</p>
                        </div>
                      )}
                    </div>
                  </Tab>
                  {/* Tab 5: Overview - Custom button that navigates to performance page */}
                  <Tab
                    eventKey="overview"
                    title="Overview"
                    tabClassName="overview-tab"
                    onEnter={() => navigate(`/admin/course-performance/${id}`)}
                  >
                  </Tab>
                </Tabs>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div >
      {/* Delete Confirmation Modal */}
      < DeleteModal
        showdt={showDeleteModal}
        handleCloseDt={() => {
          setShowDeleteModal(false);
          setSelectedSchool(null);
        }}
        handledelete={handleRemoveSchool}
        title="Remove School"
        message={`Are you sure you want to remove "${selectedSchool?.school_name}" from this course?`}
      />

      {/* Assign School Modal */}
      <Modal
        show={showAssignModal}
        onHide={() => {
          setShowAssignModal(false);
          setSelectedSchoolId("");
        }}
        centered
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Assign School to Course</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Course</Form.Label>
              <Form.Control
                type="text"
                value={`${courseData?.title} (${courseData?.unique_course_id})`}
                disabled
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Select School <span className="text-danger">*</span></Form.Label>
              {loadingSchoolsList ? (
                <div className="text-center py-2">
                  <Spinner animation="border" size="sm" />
                  <span className="ms-2">Loading schools...</span>
                </div>
              ) : (
                <Select
                  options={allSchools}
                  value={selectedSchoolId}
                  onChange={setSelectedSchoolId}
                  placeholder="Search and select a school..."
                  isClearable
                  isSearchable
                  noOptionsMessage={({ inputValue }) =>
                    inputValue ? `No schools found matching "${inputValue}"` : "Type to search schools..."
                  }
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: '42px',
                      borderColor: '#ced4da',
                      '&:hover': {
                        borderColor: '#80bdff'
                      }
                    })
                  }}
                />
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowAssignModal(false);
            setSelectedSchoolId("");
          }}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAssignSchool}>
            Assign School
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Topic Modal */}
      <Modal
        show={showTopicEditModal}
        size="md"
        onHide={() => {
          setShowTopicEditModal(false);
          setSelectedTopic(null);
          setTopicName("");
        }}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="font_blue_20 font-600">
            Edit Topic
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="mb-3 align-items-start font_blue_18">
            <Col md={12} lg={12}>
              <Form.Group controlId="topicName" className="w-100">
                <Form.Label className="font_blue_14 font-500">
                  Name:
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Topic name"
                  value={topicName}
                  onChange={(e) => setTopicName(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="warning"
            className="success_btn"
            onClick={handleTopicEdit}
            disabled={editLoad}
          >
            {editLoad ? "Processing..." : "Update"}
          </Button>
          <Button
            variant="secondary"
            className="cancel_btn"
            onClick={() => {
              setShowTopicEditModal(false);
              setSelectedTopic(null);
              setTopicName("");
            }}
            disabled={editLoad}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Topic Modal */}
      <DeleteModal
        showdt={showTopicDeleteModal}
        handleCloseDt={() => {
          setShowTopicDeleteModal(false);
          setSelectedTopicId(null);
        }}
        handledelete={handleTopicDelete}
        title="Delete Topic"
        message="Are you sure you want to delete this topic?"
      />
      <ToastContainer />
    </>
  );
};

export default CourseDetails;